import * as L from 'leaflet';
import { LatLngExpression, MarkerOptions } from 'leaflet';

export class AssetMapMarker extends L.Marker {
  constructor(latLng: LatLngExpression,
              options: MarkerOptions,
              public assetId: string,
              public defaultMarkerIcon: L.Icon<L.IconOptions>,
              public selectedMarkerIcon: L.Icon<L.IconOptions>) {
    super(latLng, options);
  }

  public select(): void {
    this.setIcon(this.selectedMarkerIcon);
  }

  public unSelect(): void {
    this.setIcon(this.defaultMarkerIcon);
  }
}
